import { Group, Code } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { GroupBadge } from 'components/GroupBadge';
import { useUserData } from 'hooks/api/useUser';
import { MeasurementDetails } from './MeasurementDetails';

export const useSymptomsName = (symptoms?: string[]) => {
  const { t } = useTranslation();
  if (!symptoms)
    return (
      <Group>
        <Code bg={'var(--mantine-color-gray-3)'}>{t('symptom_no_symptoms')}</Code>
      </Group>
    );

  return (
    <Group>
      {symptoms.map((symp) => (
        <Code key={`symptom-${symp}`} bg={'var(--mantine-color-gray-3)'}>
          {t(`symptom_${symp}`)}
        </Code>
      ))}
    </Group>
  );
};

export const useGroupNameById = (groupIds?: string[]) => {
  const { data: userData } = useUserData();

  const userGroupList = userData?.visibleGroups;

  if (groupIds) {
    const allFoundGroups = groupIds?.map((groupId) => {
      return userGroupList?.find((group) => group.id === groupId) || '';
    });

    return (
      <Group>
        {allFoundGroups.map((group) => {
          if (group) {
            return <GroupBadge label={group.name} key={group.id} groupId={group.id} />;
          }
          return '';
        })}
      </Group>
    );
  }
  return '';
};

export const renderMeasurementDetails = (moreIds?: string[]) => {
  return <MeasurementDetails moreIds={moreIds} />;
};
